<template>
    <div class="tw-p-4 legacy-lg:tw-p-6 tw-grid tw-gap-10">
        <ServiceHeader class="tw-relative tw-z-10" :service="service" />
        <BaseYoutubeVideo class="tw-relative tw-z-10" v-if="service.youtube_embed_link" :url="service.youtube_embed_link" />
        <ServiceBackground :src="service.image(600)" />
    </div>
</template>
<script>
import ServiceHeader from "./view/service-header";
import Service from "../../models/service";
import ServiceBackground from "./view/service-background";
import BaseYoutubeVideo from "../base/base-youtube-video";

export default {
    components: {
        BaseYoutubeVideo,
        ServiceBackground,
        ServiceHeader
    },
    props: {
        service: {
            type: Service,
            required: true
        }
    }
};
</script>
